/*
 * Copyright (c) 2021 Promontory Interfinancial Network, LLC
 */

export enum MfaOptions {
  sms_mfa = 'SMS_MFA',
  software_token_mfa = 'SOFTWARE_TOKEN_MFA',
  email_mfa = 'EMAIL_MFA'
}
